import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { MsalService } from '@azure/msal-angular';
import { Observable, from, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private msalService: MsalService
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.authService.getIsLoggedIn().pipe(
      switchMap((isLoggedIn) => {
        if (isLoggedIn) {
         // Check if roles are already cached  
          const roles = this.authService.getCachedRolesSync();
          if (roles) {
            return of(true);
          } else {
           // Fetch and cache roles if not already present  
            return from(this.authService.fetchAndCacheRoles()).pipe(
              map(() => true)
            );
          }
        } else {
          // Use MSAL's redirectStartPage so the user is returned to the
          // requested URL after login — no sessionStorage needed.
          this.msalService.loginRedirect({
            scopes: environment.msal.scopes,
            redirectStartPage: state.url
          });
          return of(false);
        }
      })
    );
  }
}
